import { TrackFocus } from '@homeaway/a11y-tools';

const initializeTrackFocus = () => {
  const trackFocus = new TrackFocus();
  trackFocus.bindEvents();
};

export {
  initializeTrackFocus
};